import script from "./TaggedDeliverySummary.vue?vue&type=script&lang=ts&setup=true"
export * from "./TaggedDeliverySummary.vue?vue&type=script&lang=ts&setup=true"

import "./TaggedDeliverySummary.vue?vue&type=style&index=0&id=3dfa2fd9&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dfa2fd9"]])

export default __exports__